import Dexie from 'dexie';

// Use a fresh database namespace to completely bypass legacy IndexedDB locks
export const db = new Dexie('HomeInventoryDB_v4');

db.version(1).stores({
  items: 'id, name, category, location, category_id, location_id, sync_status, updated_at',
  categories: 'id, name, sync_status, updated_at',
  locations: 'id, name, parent_id, sync_status, updated_at',
  tags: 'id, name, sync_status, updated_at'
});

// Self-healing database open to resolve native WebView schema or upgrade failures
db.open().catch(async (err) => {
  console.error("Dexie database open failed, executing self-healing prune:", err);
  try {
    await db.delete();
    await db.open();
    console.log("Dexie database successfully self-healed and re-opened!");
  } catch (healError) {
    console.error("Critical error: Dexie database failed to self-heal:", healError);
  }
});

// Helper to generate a unique local ID for offline creation
export const generateLocalId = (prefix = 'local_') => {
  return `${prefix}${Date.now()}_${Math.random().toString(36).substring(2, 11)}`;
};

// Helper to get Korean Choseong for search matching
export const getChoseong = (str) => {
  if (!str) return '';
  const cho = [
    'ㄱ', 'ㄲ', 'ㄴ', 'ㄷ', 'ㄸ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅃ', 'ㅅ',
    'ㅆ', 'ㅇ', 'ㅈ', 'ㅉ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'
  ];
  let result = '';
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i) - 44032;
    if (code > -1 && code < 11172) {
      result += cho[Math.floor(code / 588)];
    } else {
      result += str.charAt(i);
    }
  }
  return result;
};
